import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, notification } from 'antd';
import TagForm from './TagForm';
import { connect } from 'react-redux';
import { Button, message } from 'antd';
import { spacing } from '../../lib/theme';
import { getIsPremiumUser } from '../../lib/fileUtils';
import { playlistPremiumLimit, tagPremiumLimit } from '../../lib/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class NewTag extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    }
    showModal = () => {
        const { userDetails, podcastTags } = this.props;
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to create a collection.');
            return;
        }
        if (!getIsPremiumUser() && Object.keys(podcastTags).length >= tagPremiumLimit) {
            notification.info({
                // duration: 0,
                message: 'Please move to premium version to create more than ' +
                    tagPremiumLimit +
                    ' collections',
            });
            return;
        }
        this.setState({
            visible: true,
        });
    }

    handleOk = (loading, newTagId) => {
        console.log('loading : ' + loading);
        // this.setState({
        //     confirmLoading: loading,
        // });
        // if (typeof this.props.callOrigParent !== 'undefined') {
        //     this.props.callOrigParent(playlistInfo);
        // }
        // if (!loading) {
        console.dir(newTagId);
        setTimeout(() => {
            this.setState({
                visible: false,
            });
        }, 100);
        if (newTagId) {
            if (this.props.callOrigParent) {
                this.props.callOrigParent(newTagId);
            }
        }
        // window.location.reload();
        // }
    }

    handleCancel = () => {
        console.log('Clicked cancel button');
        this.setState({
            visible: false,
        });
    }
    render() {
        const { podcastDetails, edit, display, podcastTags, editTagId } = this.props;
        console.log(edit);
        let tagName = ''
        if (edit) {
            const tagMap = podcastTags[editTagId] ?? {};
            tagName = tagMap['name'] ?? '';
        }
        const { visible, confirmLoading } = this.state;
        return (
            <div>
                <Modal
                    title={<h4 className='mb-0'>Collection</h4>}
                    visible={visible}
                    onOk={this.handleOk}
                    confirmLoading={confirmLoading}
                    onCancel={this.handleCancel}
                    footer={null}
                    width={400}
                >
                    <TagForm podcastDetails={podcastDetails} callBackParent={this.handleOk} tagName={tagName}
                        edit={edit} editTagId={editTagId} />
                </Modal>
                {/* {!edit && display !== 'btn' && <p style={{ padding: `${spacing('xs')} ${spacing()}`, marginBottom: 0 }} onClick={this.showModal}>New playlist</p>} */}
                {!edit && <Button type='primary' style={{ width: '100%', borderRadius: '8px' }} onClick={this.showModal}>New Collection</Button>}
                {edit && <p style={{ padding: '2px 12px', marginBottom: 0, cursor: 'pointer' }} onClick={this.showModal}><FontAwesomeIcon icon='edit' style={{ fontSize: '16px' }} /></p>}
            </div>
        )
    }
}

NewTag.propTypes = {
    edit: PropTypes.bool,
    editTagId: PropTypes.string,
    display: PropTypes.string,
    userDetails: PropTypes.object,
    podcastDetails: PropTypes.object,
    podcastTags: PropTypes.object,
    callOrigParent: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        podcastTags: state.podcastTags,
    }
}
export default connect(mapStateToProps, null)(NewTag)
